"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const search_svg_1 = __importDefault(require("images/utility-icons/search.svg"));
const Results_1 = __importDefault(require("./Results"));
const ResultsWrapper_1 = __importDefault(require("./ResultsWrapper"));
function PracticeSearchForm({ handleSubmit, clearPracticeLocations, getPracticeLocations, practiceLocations, setPracticeLocations, useStyle = true, displayOptions = {
    showPrequalify: true,
    placeholder: 'Practice Name, Address, or Phone Number',
}, }) {
    // State
    const [practiceLocationSuggestions, setPracticeLocationSuggestions] = (0, react_1.useState)([]);
    // Func - submit
    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit(e);
    };
    // Func - click
    const handleClick = (item) => {
        handleSubmit(item);
    };
    // Debounce
    const getPracticeLocationsDebounced = (0, lodash_1.debounce)((queryType, value) => {
        getPracticeLocations(queryType, value);
    }, 500);
    // Effects
    (0, react_1.useEffect)(() => {
        clearPracticeLocations();
    }, []);
    (0, react_1.useEffect)(() => {
        setPracticeLocationSuggestions(practiceLocations);
    }, [practiceLocations]);
    const findPractice = (e) => {
        if (e.target.value && e.target.value != '') {
            getPracticeLocationsDebounced('all', e.target.value);
        }
        else {
            setPracticeLocations([]);
        }
    };
    return ((0, jsx_runtime_1.jsx)("form", { className: "results", noValidate: true, onSubmit: onSubmit, children: (0, jsx_runtime_1.jsxs)("div", { className: "practice-search-wrapper", style: { zIndex: 1000 }, children: [(0, jsx_runtime_1.jsx)("img", { src: search_svg_1.default, className: "magGlass", alt: "search" }), (0, jsx_runtime_1.jsx)("input", { name: "searchCriteria", placeholder: displayOptions.placeholder, onChange: findPractice, type: "search" }), (0, jsx_runtime_1.jsx)(ResultsWrapper_1.default, { useStyle: useStyle, children: (0, jsx_runtime_1.jsx)(Results_1.default, { handleClick: handleClick, results: practiceLocationSuggestions, showPrequalify: displayOptions.showPrequalify }) })] }) }));
}
exports.default = PracticeSearchForm;
